import React from 'react';

import PlusImg from '../assets/plusImg.svg'

import '../css/AddSpaces.scss';

export default function AddSpaces() {
    const addSpaces = () => {
        console.log('add spaces');
    }
    return (
        <div className='spaces-container flex-container space-between' onClick={() => addSpaces()}>
            <img src={PlusImg} className='plus-img' alt="white plus sign" />
            <p className='spaces-content'>Add $PACES</p>
        </div>
    )
}